import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ActivitySourceComponent from './activity_source';
import ConversationComponent from './conversation';
import LikeContainer from '../containers/like_container';
import RepliesStates from '../types/replies_states';
import ShowRepliesButton from './show_replies_button';

const Activity = ({ activity, currentUser }) => {
  const { source, conversation, creator } = activity;
  source.creator = creator;

  if (!conversation) {
    return null;
  }

  const [repliesCount, setRepliesCount] = useState(conversation.messages.filter(message => message.parentId === null).length);
  const [repliesState, setRepliesState] = useState(repliesCount > 3 ? RepliesStates.FIRST_THREE : RepliesStates.SHOW_INCREMENT_AMOUNT);

  const handleRepliesState = (newRepliesState) => {
    setRepliesState(newRepliesState);
  };

  const handleRepliesCount = () => {
    setRepliesCount(repliesCount + 1);
  };

  return (
    <div className="activity module-content">
      <ActivitySourceComponent source={ source } creator={ creator } community={ activity.community } />

      <div className="message-actions">
        <LikeContainer likeable={ activity } likeableType={ 'Activity' } />
        <ShowRepliesButton
            messages={ conversation.messages }
            repliesCount={ repliesCount }
            repliesState={ repliesState }
            handleRepliesState={ handleRepliesState } />
      </div>

      <ConversationComponent
          key={ conversation.id }
          currentUser={ currentUser }
          conversation={ conversation }
          repliesState={ repliesState }
          handleRepliesCount={ handleRepliesCount }
          handleRepliesState={ handleRepliesState } />
    </div>
  );
};

Activity.propTypes = {
};

export default Activity;
